<template lang='pug'>
	.calcerts(id='home')
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="CalCerts Registration Instructions")
		contentCalcerts
		v-e24-footer(:build="build")
</template>

<script>
import headerResources from '@/commonSite/header.vue'
import contentCalcerts from '@/components/resources/content-calcerts.vue'
import imageHeader from '@/img/faq-header.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'calcerts-reg',
	components: {
		headerResources,
		contentCalcerts
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/CalcertsReg.vue